import React, { createContext, useContext, useState } from 'react';
// ❌ Suppression de l'import de useNavigate. Il ne doit pas être ici.
// import { useNavigate } from 'react-router-dom'; 

// 1. Define the Context
const AuthContext = createContext(null);

// Hardcoded users for testing Role-Based Access Control (RBAC)
const TEST_USERS = {
"admin": { username: "admin", role: "administrator", password: "password123" },
"agent": { username: "agent", role: "agent", password: "password123" },
"manager": { username: "manager", role: "management", password: "password123" }
};

// 2. Define the Provider Component
export const AuthProvider = ({ children }) => {
// ❌ Suppression de l'appel à useNavigate : la navigation doit se faire dans le composant appelant.
// const navigate = useNavigate();  
// State to hold the current user (loaded from session storage or null)
const [user, setUser] = useState(() => {
const storedUser = sessionStorage.getItem('safewings_user');
return storedUser ? JSON.parse(storedUser) : null;
});

// 3. Login Function
const login = (username, password) => {
const foundUser = Object.values(TEST_USERS).find(
u => u.username === username && u.password === password
);

if (foundUser) {
// Store user details (excluding password) in session storage
const { password, ...userSession } = foundUser;
sessionStorage.setItem('safewings_user', JSON.stringify(userSession));
setUser(userSession);
return true; // Login successful
}
return false; // Login failed
};

// 4. Logout Function (Ne fait plus de redirection ici)
const logout = () => {
sessionStorage.removeItem('safewings_user');
  setUser(null);
// ❌ Suppression de la redirection : elle sera gérée par le composant appelant.
// navigate('/'); 
};

// 5. Context Value
const value = {
user,
isLoggedIn: !!user,
role: user ? user.role : 'guest', // Exposes the user role
login,
logout,
};

return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

// 6. Define the Hook for easy consumption
export const useAuth = () => {
return useContext(AuthContext);
};